<template>
    <VueDatepicker
            v-model="date"
            :state="true"
            :autoApply="true"
            :enableTimePicker="false"
            :name="name"
            :uid="id"
            locale="es-es"
            :placeholder="placeholder"
            @update:modelValue="handleDate"
    ></VueDatepicker>
</template>

<script>
    import VueDatepicker from '@vuepic/vue-datepicker';
    import '@vuepic/vue-datepicker/dist/main.css'

    export default {
        name: 'datepicker',
        components: { VueDatepicker },
        emits: ['update'],
        props: {
            id : {
                type: String
            },
            name : {
                type: String
            },
            placeholder : {
                type: String
            },
            selectedValue: {
                type: String
            },
        },
        data() {
            return {
                date: null,
            };
        },
        methods: {
            handleDate: function (value) {
                let data = {'name' : this.name};
                if (typeof value === 'undefined' || typeof value === 'null' || !value) {
                    data['value'] = null;
                } else {
                    let date = new Date(value);
                    data['value'] = date.getFullYear() + '-' + date.getMonth() + '-' + date.getDate();
                }
                this.$emit('update', data);
            }
        },
        watch: {
            selectedValue: function(newVal, oldVal) {
                this.date  = newVal;
            }
        }
    }
</script>
